AuthRoute = require 'mixins/authenticated-route'

App.MobileAppRoute = Em.Route.extend AuthRoute,
  beforeModelAuth: ->
    organization = @get('session').get('currentOrganization')
    @controllerFor('mobile-app').set('organization', organization)

  model: ->
    organization = @controllerFor('mobile-app').get('organization')
    @store.find('skin', organization_id: organization.get('id'))

  afterModel: (skins) ->
    new Em.RSVP.Promise (resolve, reject) =>
      @store.find('theme').then (themes) =>
        @controllerFor('mobile-app').set('themes', themes)

        Em.RSVP.all(
          skins.map (skin) ->
            skin.get('theme')
        ).then(resolve, reject)

  setupController: (controller, model) ->
    @_super(arguments...)

    Em.run.next =>
      selectedSkin = controller.get('selectedSkin')
      controller.set('isSelectingTheme', Em.isBlank(selectedSkin))